export const DiscountTypeEnum = {
    REGULAR: 'regular_campaign',
    BLACKFRIDAY: 'black_friday',
};
